import { render, staticRenderFns } from "./AdminDestroyedObjectSearch.vue?vue&type=template&id=37c842ca&"
import script from "./AdminDestroyedObjectSearch.vue?vue&type=script&lang=js&"
export * from "./AdminDestroyedObjectSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports